import { render } from "./LiberatedGasCompositon.vue?vue&type=template&id=71b986ee"
import script from "./LiberatedGasCompositon.vue?vue&type=script&lang=js"
export * from "./LiberatedGasCompositon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__